var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    fill: "#5C5E69"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.75C6.5 8.85254 7.22754 8.125 8.125 8.125H17.875C18.7725 8.125 19.5 8.85254 19.5 9.75V16.25C19.5 17.1475 18.7725 17.875 17.875 17.875H8.125C7.22754 17.875 6.5 17.1475 6.5 16.25V9.75ZM8.125 8.9375C7.67627 8.9375 7.3125 9.30127 7.3125 9.75V9.92623L13 13.3387L18.6875 9.92623V9.75C18.6875 9.30127 18.3237 8.9375 17.875 8.9375H8.125ZM18.6875 10.8738L14.8622 13.169L18.6875 15.523V10.8738ZM18.6601 16.4601L14.0772 13.6399L13 14.2863L11.9228 13.6399L7.33993 16.4601C7.43254 16.807 7.74893 17.0625 8.125 17.0625H17.875C18.2511 17.0625 18.5675 16.807 18.6601 16.4601ZM7.3125 15.523L11.1378 13.169L7.3125 10.8738V15.523Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.5a3482fb8b019c67f442e7e049774b19.svg";
export { ForwardRef as ReactComponent };